import AxiosClient from '../../../../functional/Axios/AxiosClient';

export const apiDirections = {
  fetchDirections: () => AxiosClient.get('/root/directions'),
  fetchDirectionServices: ({ id }) => AxiosClient.get(`/root/services/direction/${id}`),
  addDirection: (data) => AxiosClient.post('/root/directions', data),
  deleteDirection: (id) => AxiosClient.delete(`/root/directions/${id}`),
  addMisId: (data) => AxiosClient.post('/root/directions/misId/', data),
};
